import { DossierDetailsView } from "@/app/pages/dossier/dossier-details-panel";
import { useGetTvvBesteldeRoutes } from "@/entities/tvv";
import { BestelRoutesProvider } from "@/features/tvv/components/regievoerder/bestel-routes-provider.tsx";
import { BesteloverzichtView } from "@/features/tvv/components/regievoerder/besteloverzicht";
import { TvvDetailsSkeleton } from "@/features/tvv/components/shared";

type TvvDetailsAlleenLezenProps = {
    dossierId: string;
};

export function TvvDetailsAlleenLezen({ dossierId }: Readonly<TvvDetailsAlleenLezenProps>) {
    const query = useGetTvvBesteldeRoutes(dossierId);

    return (
        <DossierDetailsView section="Tvv" query={query} skeleton={<TvvDetailsSkeleton />}>
            {(besteldeRoutes) => (
                <BestelRoutesProvider dossierId={dossierId} besteldeRoutes={besteldeRoutes}>
                    <BesteloverzichtView dossierId={dossierId} />
                </BestelRoutesProvider>
            )}
        </DossierDetailsView>
    );
}
